export default {"src":"/_next/static/media/schraubenschluessel.fed89c38.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};